import * as _ from 'lodash-es';

export function ForceSameUser(stateName, currentUser, params, PromiseConstructor) {

    return new Promise<void>((resolve, reject) => {
        if (_.get(currentUser, 'isSiteAdmin', false)) {
            resolve();
        } else {
            var unixName = _.get(currentUser, 'unixName', '');
            var routeUN = _.get(params, 'unixName', '');

            if (unixName.toUpperCase() == routeUN.toUpperCase()) {
                resolve();
            } else {
                reject({
                    redirectTo: {
                        state: stateName,
                        params: { unixName: unixName }
                    }
                });
            }
        }
    });
};
